export default __webpack_public_path__ + "static/media/chart-yellow.f4937470.svg";